var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center font-bold leading-none cursor-pointer",class:_vm.classObj},[_c('span',[_vm._v("Act")]),_c('span',[_vm._v("Circular")]),_c('span',[_vm._v("Now")])])}
var staticRenderFns = []

export { render, staticRenderFns }